export const titlesHeaderMyProposalsModel = [
    {
        id: 1,
        label: "Dossier",
        key: "folder",
        sortable: false,
        thStyle: { width: "36%" },
    },
    {
        id: 2,
        label: "Date Envoyé",
        key: "dateE",
        sortable: true,
        thStyle: { width: "15%" },
    },
    {
        id: 3,
        label: "Date Limite",
        key: "dateL",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 4,
        label: "Etat",
        key: "state",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 5,
        label: "Action",
        key: "action",
        sortable: false,
        thStyle: { width: "15%" },
    },
];

export const titlesHeaderProposalsModel = [
    {
        id: 1,
        label: "Titre",
        key: "title",
        sortable: true,
        thStyle: { width: "30%" },
    },
    {
        id: 2,
        label: "Date Proposition",
        key: "dateP",
        sortable: false,
        thStyle: { width: "22%" },
    },
   
];

export const titlesHeaderCatalogModel = [
    {
        id: 1,
        label: "#",
        key: "id",
        sortable: true,
        thStyle: { width: "5%" },
    },
    {
        id: 2,
        label: "Avancement",
        key: "advancement",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 3,
        label: "Type du bien",
        key: "type",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 4,
        label: "Usage du bien",
        key: "Use",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 5,
        label: "Montant",
        key: "amount",
        sortable: false,
        thStyle: { width: "10%" },
    },
    {
        id: 6,
        label: "Durée de crédit souhaité",
        key: "duration",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 7,
        label: "Montant revenus total",
        key: "total_amount",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 8,
        label: "Code postal",
        key: "s_codepostal",
        sortable: true,
        thStyle: { width: "15%" },
    },
    {
        id: 9,
        label: "Date limite de publication",
        key: "date",
        sortable: false,
        thStyle: { width: "10%" },
    },
    
    {
        id: 10,
        label: "Action",
        key: "action",
        sortable: false,
        thStyle: { width: "15%" },
    },
    
    
];

export const titlesHeaderFoldersModel = [
    {
        id: 1,
        label: "#",
        key: "id",
        sortable: true,
        thStyle: { width: "5%" },
    },
    {
        id: 2,
        label: "Dossier",
        key: "folder",
        sortable: true,
        thStyle: { width: "20%" },
    },
    {
        id: 3,
        label: "Date",
        key: "date",
        sortable: false,
        thStyle: { width: "10%" },
    },
    {
        id: 4,
        label: "Montant",
        key: "amount",
        sortable: false,
        thStyle: { width: "10%" },
    },
    {
        id: 5,
        label: "Type du bien",
        key: "type",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 6,
        label: "Statut",
        key: "status",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 7,
        label: "Usage du bien",
        key: "Use",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 8,
        label: "Action",
        key: "action",
        sortable: false,
        thStyle: { width: "15%" },
    },
];

export const titlesHeaderProposalsModelMy = [
    {
        id: 1,
        label: "#",
        key: "id",
        sortable: false,
        thStyle: { width: "10%" },
    },
    {
        id: 2,
        label: "Dossier",
        key: "folder",
        sortable: false,
        thStyle: { width: "36%" },
    },
    {
        id: 3,
        label: "Date Envoyé",
        key: "dateE",
        sortable: true,
        thStyle: { width: "15%" },
    },
    {
        id: 4,
        label: "Date Limite",
        key: "dateL",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 5,
        label: "Etat",
        key: "state",
        sortable: false,
        thStyle: { width: "15%" },
    },
    {
        id: 6,
        label: "Action",
        key: "action",
        sortable: false,
        thStyle: { width: "15%" },
    },
];